import type {CompRef, PS} from '@wix/document-services-types'
import actionsAndBehaviors from '../../actionsAndBehaviors/actionsAndBehaviors'
import documentInfo from '../../documentMode/documentModeInfo'
import page from '../../page/page'
import popupUtils from '../../page/popupUtils'
import structure from '../../structure/structure'
import type {AdjustComponentLayoutFromExtEvent} from '@wix/document-manager-extensions/dist/src/extensions/components/hooks'

function getContainerToAddTo(ps: PS, containerPointer) {
    if (ps.pointers.components.isPage(containerPointer) && page.popupPages.isPopup(ps, containerPointer.id)) {
        return popupUtils.getPopupContainer(ps, containerPointer)
    }

    return containerPointer
}

function removeDeadBehaviors(ps: PS, popupPointer) {
    const isPopup = page.popupPages.isPopup(ps, popupPointer.id)
    if (!isPopup) {
        return
    }

    const viewMode = documentInfo.getViewMode(ps)
    const pagePointers = page.getPageIdList(ps, true).map(pageId => ps.pointers.components.getPage(pageId, viewMode))

    pagePointers.forEach(function (pagePointer) {
        actionsAndBehaviors.removeComponentsBehaviorsWithFilter(ps, pagePointer, {
            behavior: {targetId: popupPointer.id}
        })
    })
}
function adjustCompLayoutInPopupPageFromExt(ps: PS, data: AdjustComponentLayoutFromExtEvent) {
    const {compToAddPointer, containerPointer} = data
    structure.adjustCompLayoutToNewContainer(ps, compToAddPointer, containerPointer as CompRef)
}

export default {
    getContainerToAddTo,
    removeDeadBehaviors,
    adjustCompLayoutInPopupPageFromExt
}
